import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Typography,
  Button,
  TextField,
  Alert
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { signup } from '../actions/userActions'

const SignupCard = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  })

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { error, userInfo } = useSelector(state => state.userState)

  useEffect(() => {
    if (userInfo && userInfo.token) {
      navigate('/profile')
    }
  }, [navigate, userInfo])

  const submitHandler = e => {
    e.preventDefault()
    dispatch(signup(formData.name, formData.email, formData.password))
  }

  const changeField = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  return (
    <>
      <Typography sx={{ mb: 3 }} variant='h6'>Signup</Typography>
      {error && <Alert sx={{ mb: 3 }} severity='error'>{error}</Alert>}
      <form onSubmit={submitHandler}>
        <TextField
          label='Name'
          name='name'
          fullWidth
          sx={{ mb: 3 }}
          value={formData.name}
          onChange={changeField}
        />
        <TextField
          label='Email'
          name='email'
          type='email'
          fullWidth
          sx={{ mb: 3 }}
          value={formData.email}
          onChange={changeField}
        />
        <TextField
          label='Password'
          name='password'
          type='password'
          fullWidth
          sx={{ mb: 3 }}
          value={formData.password}
          onChange={changeField}
        />
        <Button variant='contained' type='submit' fullWidth>Signup</Button>
      </form>
    </>
  )
}

export default SignupCard